/**
 * src/components/header/NavLogo.js
 *
 * Logo del header. Si se pasa `brand`, muestra texto al lado de la imagen;
 * si no, muestra solo la imagen (cuando el logo ya incluye el wordmark).
 * Props: { src, alt, brand, tagline }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('NavLogo', ({ src, alt, brand, tagline }) => {
    const children = [
        h('img', { src, alt, className: 'nav-logo__img' })
    ]
    if (brand) {
        children.push(
            h('span', { className: 'nav-logo__text' },
                h('strong', { className: 'nav-logo__brand' }, brand),
                h('small',  { className: 'nav-logo__tagline' }, tagline)
            )
        )
    }
    return h('a', { className: 'nav-logo', href: '/' }, ...children)
})
